var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex items-center justify-center rounded-full",class:[_vm.avatarSize, _vm.avatarColor]},[_vm._v("\n  "+_vm._s(_vm.userNameAbbr)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }